export default function (html) {
  html = replaceCodeBlocks(html);
  return html;
}
function replaceCodeBlocks(html) {
  let regex = new RegExp(/```([\s\S]+)```/g);
  return html.replace(regex, function (match, p1) {
    return `<code>${p1}</code>`;
  });
}